import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFSlots } from 'utils/types';
import css from './SlotsView.css';
import { Loader } from 'semantic-ui-react';
import Schedule from './Schedule'
import ServiceCalendarInstruction from 'common/ReadMoreLessText';

export default class SlotsView extends React.Component {

  get content() {
    const { hasFetched, ...props } = this.props;
    return hasFetched || (props.slots && props.slots.length > 0)
      ? <Schedule {...props} />
      : <div><Loader active inline='centered'>Loading time slots...</Loader></div>;
  }

  get serviceCalendarInstruction() {
    const { serviceCalendarInstruction, isService, serviceCalendarEnabled } = this.props;
    return isService && serviceCalendarEnabled && serviceCalendarInstruction && serviceCalendarInstruction.trim().length > 0 
      ? <ServiceCalendarInstruction text={serviceCalendarInstruction} />
      : '';
  }

  render() {
    return (
      <div className={css['content']}>
        <div>What day and time works for you?</div>
        <div>
          The appointment times you see do not overlap with your already scheduled appointments.
          {this.serviceCalendarInstruction}
        </div>
        {this.content}
      </div>
    );
  }
}

SlotsView.propTypes = {
  slots: SFSlots,
  recurring: PropTypes.bool,
  hasFetched: PropTypes.bool.isRequired,
  slotStartDate: PropTypes.object,
  slotOwnerId: SFEntityID,
  onSlotSelected: PropTypes.func.isRequired,
  isService: PropTypes.bool.isRequired,
  currentDuration: PropTypes.number,
  locationName: PropTypes.string,
  serviceCalendarInstruction: PropTypes.string,
  serviceCalendarEnabled: PropTypes.bool,

  // Injected by FilterControls, can't be required because they are dynamic
  numberOfVisibleSlots: PropTypes.number,
  onShowMoreSlotsButtonClick: PropTypes.func,
  showGroupSessions: PropTypes.bool,
  showSingleSessions: PropTypes.bool,
  onSlotTypeDropdownChanged: PropTypes.func,
  filterStartDate: PropTypes.object,
  filterEndDate: PropTypes.object,
  onFilterStartDateChanged: PropTypes.func,
  onFilterEndDateChanged: PropTypes.func
};
